export const AVAILABLE_COLUMNS = [
  { name: 'StatusDescription', alias: 'Status' },
  { name: 'Subject', alias: 'Subject' },
  { name: 'ToDesc', alias: 'To' },
  { name: 'CCDesc', alias: 'Cc' },
  { name: 'BCCDesc', alias: 'Bcc' },
  { name: 'Message', alias: 'Message' },
  { name: 'SentBy', alias: 'Sent By ID' },
  { name: 'SentByName', alias: 'Sent By Name' },
  { name: 'SentDate', alias: 'Sent Date' },
  { name: 'audit', alias: 'Audit' },
  { name: 'report', alias: 'Report' },
  { name: 'edit', alias: 'Open' },
  { name: 'preview', alias: 'Preview' }
];
